module.exports = __webpack_public_path__ + "static/logo-124d19f138f3f1f743d0003553d6aa0f.png";